module.exports = __webpack_public_path__ + "static/img/wealth_level_84.04641df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_84.png
// module id = JWPz
// module chunks = 0